import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Image from 'next/legacy/image';
import { NEXT_STATIC_IMAGES, SHARED_MEDIA_QUERIES as sharedMediaQueries } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import Carousel from 'src/common/components/dockyard/Carousel';
import AppLinks from 'src/common/components/AppLinks';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import styles from './HomepageMobileApps.module.scss';

const ASSETS = `${NEXT_STATIC_IMAGES}home-page/how-it-works/`;

const steps = ['search', 'offer', 'book'];

const HomepageMobileApps: FC = () => {
  const [t] = useTranslation('home-page');

  const { isMobileNativeWebView } = useMobileNativeWebView();
  if (isMobileNativeWebView) {
    return null;
  }

  return (
    <PitchPageLayout
      backgroundImage="home-page/how-it-works/texture.png"
      backgroundColor="ivory"
    >
      <div className={styles.root}>
        <div className={styles.title}>
          <Typography
            type="h3"
            size="display-5"
            sizeFromBreakpointM="display-4"
          >
            {t('mobile-apps--title')}
          </Typography>
        </div>
        <CarouselProvider
          emblaOptions={{
            active: true,
            breakpoints: {
              [sharedMediaQueries.m]: {
                active: false,
              },
            },
          }}
        >
          {(selectedIndex: number) => (
            <>
              <Carousel>
                {steps.map((step) => (
                  <div key={step} className={styles.step}>
                    <div className={styles.imageWrapper}>
                      <Image
                        className={styles.image}
                        src={`${ASSETS}${step}.png`}
                        layout="fill" // images exported with negligible padding, for fixed aspect ratio between steps
                        alt={step}
                      />
                    </div>
                    <Typography
                      className={styles.subtitle}
                      type="p"
                      size="body-l"
                    >
                      {t(`mobile-apps--${step}-title`)}
                    </Typography>
                  </div>
                ))}
              </Carousel>
              <div className={styles.dots}>
                {steps.map((step, index) => (
                  <div
                    key={step}
                    className={
                      selectedIndex === index
                        ? styles.selected
                        : styles.notSelected
                    }
                  />
                ))}
              </div>
            </>
          )}
        </CarouselProvider>
        <div className={styles.appLinks}>
          <AppLinks
            classNameModifier="pitchPageHowItWorks"
            outline="midnight"
          />
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default HomepageMobileApps;
